import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/site";
import SectionTitle from "@/components/base/SectionTitle";

const iconMap: Record<string, string> = {
  anime: "ri-movie-2-line",
  manga: "ri-book-open-line",
  game: "ri-gamepad-line",
  novel: "ri-stack-line",
  voice: "ri-mic-line",
  fanwork: "ri-palette-line",
};

export default function CategoryIndex() {
  return (
    <section className="bg-background-50">
      <div className="container-site py-14 md:py-20">
        <SectionTitle
          eyebrow="资源分类索引"
          title="按板块查找你的资源"
          desc="分类索引把资源按类型归档，结合合集与归档页可快速定位到感兴趣的板块，按系列或作者批量收藏更有条理。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {siteConfig.categories.map((c) => (
            <Link
              key={c.key}
              to={`/collections?cat=${c.key}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200/70 bg-background-100/60 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-primary-100 group-hover:text-primary-800">
                <i className={`${iconMap[c.key] ?? "ri-folder-line"} text-xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-900 transition-colors group-hover:text-primary-700">
                  {c.name}
                </h3>
                <p className="mt-1 text-xs leading-5 text-foreground-600 md:text-sm">
                  {c.desc}
                </p>
              </div>
              <i className="ri-arrow-right-line ml-auto mt-1 text-base text-foreground-400 transition-transform group-hover:translate-x-1"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}